import { type AccountResponse, AccountType } from '@shared/api/rest/accounts';
import { AccountCardSmallTile } from './small/card';
import { AccountPaymentSmallTile } from './small/payment';

interface TileProps {
  account: AccountResponse;
  mainAccount?: AccountResponse;
  subAccounts: AccountResponse[];
  selectedAccountId?: number;
  onAccountSwitch: (accountId: number) => void;
}

export const AccountTileBig = (props: TileProps) => {
  return props.account.type === AccountType.Card ? (
    <AccountCardSmallTile account={props.account} />
  ) : (
    <AccountPaymentSmallTile
      account={props.account}
      subAccounts={props.subAccounts}
      selectedAccountId={props.selectedAccountId}
      onAccountSwitch={props.onAccountSwitch}
      mainAccount={props.mainAccount}
    />
  );
};
